module.exports = {"decoderTime":3000,"subtitleDelay":200,"pasteDelay":300}